import {
  AgentCursorQuestionCard,
  type AgentCursorQuestionAppearance,
  type AgentCursorQuestionData,
} from "@/components/cursors/agent-cursor-question-card";
import { cursorTextShadow } from "@/components/cursors/agent-cursor-glass";
import { useT } from "@/i18n";
import { framesConversationMessages } from "@/i18n/messages/frames-conversation";
import { cn } from "@/lib/cn";

/** The Denker question card as it sits inside a conversation or the bar. */
export function ConversationInlineQuestionCard({
  question,
  color = "var(--color-accent)",
  label,
  testId,
  className,
  onAnswered,
  onReply,
  appearance,
}: {
  question: AgentCursorQuestionData;
  color?: string;
  /** Card heading; the input bar shows "Question 1 of 2" in question mode. */
  label?: string;
  testId: string;
  className?: string;
  onAnswered?: () => void;
  onReply?: (answer: string, selectedOption: string) => Promise<boolean>;
  /** "embed" matches the inline frame cards in a conversation thread. */
  appearance?: AgentCursorQuestionAppearance;
}) {
  const t = useT(framesConversationMessages);
  return (
    <AgentCursorQuestionCard
      question={question}
      agentName={label ?? t("question")}
      agentTextShadow={cursorTextShadow(color)}
      bubbleShell={
        appearance === "embed"
          ? "rounded-preview border border-[var(--color-embed-card-stroke)]"
          : "rounded-control border border-glass-stroke-faint bg-glass-fill"
      }
      bubbleStyle={{}}
      testId={testId}
      className={cn("w-full max-w-none", className)}
      onAnswered={onAnswered}
      onReply={onReply}
      appearance={appearance}
    />
  );
}
